import React from 'react'
import { PageContent, ContentMenu, ContentMenuTab, PageFooter, Message, Text, Heading, Image } from 'components/library'
import C02A03Tab01 from './components/c02_a03_tab_01/C02A03Tab01.js'
import C02A03Tab02 from './components/c02_a03_tab_02/C02A03Tab02.js'
import C02A03Tab03 from './components/c02_a03_tab_03/C02A03Tab03.js'

import img from './assets/4.2-extra-assistentie.jpg'

import './Aspect03.css'

class Aspect03 extends React.Component {
  state = {
    currContMenuTab: 0,
    currMapTab: 0,
  }

  componentStateUpdate = idx => {
      this.setState({ currContMenuTab: idx })
  }

  liftStateTab = idx => {
    this.setState({ currMapTab: idx })
  }

  render() {
    return (
      <div className="Chapter02-Aspect03">
        <PageContent nospacing>
          <ContentMenu
            componentStateUpdate={this.componentStateUpdate}
            menuOnTop
            activeHasBackground
            tabs={[
              'Afstemming sleepbeweging',
              'Alternatieve route',
              'Noordelijke trekkerroute',
              'Zuidelijke trekkerroute',
            ]}>

            <ContentMenuTab>
              <div className="has-two-col">
                <div className="col-01">
                  <Heading h2>Afstemming Apron Control en het Jet Center</Heading>
                  <Text>Elke sleepbeweging van en naar Schiphol-Oost waarbij een vliegtuig versleept wordt, dient Apron Control met het Jet Center af te stemmen. Dit moet zodat er rekening gehouden kan worden met:</Text>
                  <ul>
                    <li>Planning van opstelplaatsen</li>
                    <li>Verrekening van havengelden</li>
                    <li>Mogelijk conflicterend verkeer waarover Apron Control met het Jet Center moet coördineren.</li>
                  </ul>
                </div>
                <div className="col-02">
                  <Image src={img}/>
                </div>
              </div>
            </ContentMenuTab>

            <ContentMenuTab>
              <C02A03Tab01/>
            </ContentMenuTab>

            <ContentMenuTab>
              <C02A03Tab02/>
            </ContentMenuTab>

            <ContentMenuTab>
              <C02A03Tab03
              liftStateTab={this.liftStateTab}/>
            </ContentMenuTab>

          </ContentMenu>
        </PageContent>
        {this.state.currContMenuTab === 3 && this.state.currMapTab === 1 ?
        <PageFooter>
          <Message info title="Let op!">
            <Text>De Zuidelijke Trekkerroute valt in zijn geheel onder de verantwoordelijkheid van Apron-Zuid. Echter de scheiding tussen Apron-Zuid en Apron-Noord ligt bij het meldpunt HG73. Indien de bestemming HG73 is, zal Apron-Zuid de route afhandelen. Indien de bestemming verder op Schiphol-Oost ligt, zal Apron-Zuid instructie geven om over te schakelen naar Apron-Noord ter hoogte van HG73. Bij vertrek vanaf HG73 naar Schiphol-Centrum dient Apron-Noord opgeroepen te worden in verband met de gebiedsindeling en verantwoordelijkheden.</Text>
          </Message>
        </PageFooter>
        : null
        }
      </div>
    )
  }
}

export default Aspect03



// WEBPACK FOOTER //
// ./src/content/chapters/02/03/Aspect03.js